import { CompassEnums } from '@sellsy/compass2';

export const invoicingHistoryAlert = {
    type: CompassEnums.AlertType.ERROR,
    enabled: true,
    featureFlag: 'invoicing-history-mode',
    text: window.i18n.__(
        "Une intervention d'import d'historique de facturation est en cours sur votre compte. Vous êtes invités à attendre la fin de l'intervention et la disparition de ce message pour créer de nouvelles factures et avoirs.",
    ),
};
